import * as yup from "yup";

import * as RHFWishListValidationRules from "@/utils/validation/schemas/wishlist.RHF";

export const WishListActionableFormValidationSchema = yup.object({
    targetId: RHFWishListValidationRules.wishListTargetId,
    name: RHFWishListValidationRules.conditionalWishlistName
});

export type WishListActionableFormValues = yup.InferType<
    typeof WishListActionableFormValidationSchema
>;
